import {FacebookMessageConfirmOrderEmpty, FacebookResponseContentScriptEmpty} from '../empty'
import {StyledFacebookResponseContentScriptTable} from './_styled'
import useFacebookMessageConfirmOrder from "../../hooks/useFacebookMessageConfirmOrder";
import {FacebookMessageConfirmOrder_Tbody} from "../_tbody";
import {FacebookMessageConfirmOrder_Thead} from "../_thead";

export const FacebookMessageConfirmOrderTable = ({rows, ...props}) => {
  const {data, methods} = useFacebookMessageConfirmOrder()

  return (
    <StyledFacebookResponseContentScriptTable {...props}>
      <FacebookMessageConfirmOrder_Thead />
      {data.pages.loading ? (
        <>
          {Array.from(Array(20), (e, i) => (
            <FacebookMessageConfirmOrder_Tbody
              key={i}
              data={null}
              loading={data.pages.loading}
            />
          ))}
        </>
      ) : (
        <>
          {rows.length > 0 ? rows?.map(item=> <FacebookMessageConfirmOrder_Tbody 
            key={item.page_id}
            onChangeStatus={methods?.onChangeStatus}
            data={item} />)
              : (
            <FacebookMessageConfirmOrderEmpty />
          )}
        </>
      )}
    </StyledFacebookResponseContentScriptTable>
  )
}
